/**
 * Klistrig huvudmeny: döljer headern när sidan scrollas nedåt och visar den
 * igen vid scroll uppåt. Sätter även `menu-open` på <body> när mobilmenyn fälls ut.
 *
 * Ersätter FrontendSrc/patternlab/js/sticky-header.js.
 */
const HEADER_HEIGHT = 120;
const SCROLL_UP = 'scroll-up';
const SCROLL_DOWN = 'scroll-down';

export function initStickyHeader(): void {
    const body = document.body;
    const navBarCollapse = document.querySelector<HTMLElement>('#navbarMainMenu');
    const navBarCollapseBtn = document.querySelector<HTMLElement>('[data-bs-target="#navbarMainMenu"]');

    if (navBarCollapseBtn && navBarCollapse) {
        navBarCollapseBtn.addEventListener('pointerdown', () => {
            body.classList.toggle('menu-open', !navBarCollapse.classList.contains('show'));
        });
    }

    let lastScroll = 0;

    // passive: scrollhanteraren rör aldrig preventDefault, och utan flaggan
    // blockeras scrollningen i väntan på den.
    window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;

        if (currentScroll <= 0) {
            body.classList.remove(SCROLL_UP);
            lastScroll = 0;
            return;
        }

        if (currentScroll > lastScroll + 5 && currentScroll > HEADER_HEIGHT
            && !body.classList.contains(SCROLL_DOWN)) {
            body.classList.remove(SCROLL_UP);
            body.classList.add(SCROLL_DOWN);
        } else if (currentScroll < lastScroll - 5 && body.classList.contains(SCROLL_DOWN)) {
            body.classList.remove(SCROLL_DOWN);
            body.classList.add(SCROLL_UP);
        }

        lastScroll = currentScroll;
    }, { passive: true });
}
